import values from 'mout/object/values'
import sortByPropText from '../content/manageSets/sortByPropText';

export default function sortItems(items) {
  let itemsArray = values(items)
  return sortByPropText(itemsArray, 'index')
}


// WEBPACK FOOTER //
// ./src/helpers/assessment/sortItems.js